<template>
  <transition name="slide-width-fade">
    <div
      class="bg-gradient-to-b from-green to-green-950 relative z-40 h-full flex flex-col justify-between"
    >
      <div
        class="absolute top-1/2 md:top-3 right-[-35px] bg-green-900 md:bg-green p-1 rounded cursor-pointer rounded-l-none border-l-0"
        v-on:click="$root.showMenu = !$root.showMenu"
      >
        <svg-icon
          :path="icons.menuOpen"
          class="text-white"
          size="28"
          type="mdi"
          v-if="$root.showMenu"
        />
        <svg-icon
          :path="icons.menuClose"
          class="text-white"
          size="28"
          type="mdi"
          v-else
        />
      </div>
      <div class="flex-grow" :class="$root.showMenu ? '' : 'hidden md:block'">
        <div class="w-full text-white my-6 px-4 h-[32px]">
          <inertia-link
            :href="route('app.task.index')"
            class="mb-10"
            @click="$root.showMapOnMobile = false"
          >
            <img
              src="/img/Livefarm_Logo_Icon_03.svg"
              alt="Livefarm"
              title="Livefarm"
              class="cursor-pointer h-full"
              v-if="!$root.showMenu"
            />
            <img
              src="/img/livefarm_logo_white.svg"
              alt="Livefarm"
              title="Livefarm"
              class="cursor-pointer h-full"
              v-if="$root.showMenu"
            />
          </inertia-link>
        </div>
        <LeftMenuItem
          :path="routes.tasks"
          title="Tasks"
          v-if="
            [
              'admin',
              'consultant',
              'consultant_user',
              'soil_sampler',
              'contractor',
              'lab_user',
              'farm_owner', // Added farm_owner so farm owners see the Tasks menu
            ].includes($page.props.auth.user.role)
          "
        >
          <svg-icon :path="icons.tasks" size="28" type="mdi" />
        </LeftMenuItem>
        <LeftMenuItem
          :path="routes.farmers"
          :title="$page.props.auth.user.role === 'farm_owner' ? 'My Farm' : 'Farmers'"
          v-if="
            ['admin', 'consultant', 'consultant_user', 'contractor', 'farm_owner'].includes(
              $page.props.auth.user.role
            )
          "
        >
          <svg-icon :path="icons.farms" size="28" type="mdi" />
        </LeftMenuItem>
        <LeftMenuItem
          :path="routes.users"
          title="Users"
          v-if="
            ['admin', 'consultant', 'consultant_user', 'contractor'].includes(
              $page.props.auth.user.role
            )
          "
        >
          <svg-icon :path="icons.users" size="28" type="mdi" />
        </LeftMenuItem>
        <LeftMenuItem
          :path="routes.organisations"
          title="Organisations"
          v-if="$page.props.auth.user.role == 'admin'"
        >
          <svg-icon :path="icons.organisations" size="28" type="mdi" />
        </LeftMenuItem>

        <!-- Settings -->
        <LeftMenuItem
          :path="routes.settings"
          title="Settings"
          v-if="$page.props.auth.user.role == 'admin'"
        >
          <svg-icon :path="icons.settings" size="28" type="mdi" />
        </LeftMenuItem>

        <!-- Account -->
        <LeftMenuItem
          :path="routes.account"
          title="Account"
          class="absolute bottom-0"
        >
          <svg-icon :path="icons.account" size="28" type="mdi"
        /></LeftMenuItem>
      </div>
    </div>
  </transition>
</template>

<script>
import BreezeNavLink from "@/Components/NavLink";
import LeftMenuItem from "./LeftMenuItem.vue";
import * as Icons from "./icons";
export default {
  components: {
    BreezeNavLink,
    LeftMenuItem,
  },
  data() {
    return {
      icons: {
        ...Icons,
      },
      routes: {
        tasks: "app.task.index",
        farmers: "app.farmer.index",
        users: "app.user.index",
        organisations: "app.organisation.index",
        settings: "app.settings.index",
        account: "app.profile.index",
      },
    };
  },

  computed: {
    showMenu() {
      return this.$root.showMenu;
    },
  },
  methods: {
    isActive(route) {
      console.log(route, " is active: ", this.route().current(route));
      return this.route().current(route);
    },
  },
};
</script>
